import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  Output,
  ViewChild,
  ChangeDetectorRef, EventEmitter, SimpleChanges, OnChanges
} from '@angular/core';
import {MapInfoWindow} from '@angular/google-maps';


export interface MapsMarkers<T = unknown> {
  lat: number,
  lon?: number,
  lng: number,
  propertyId?: string,
  data?: T
}

export interface MapClick {
  marker: MapsMarkers,
  event: google.maps.MapMouseEvent
}

@Component({
  selector: 'lib-google-maps-home365',
  templateUrl: './google-maps-home365.component.html',
  styleUrls: ['./google-maps-home365.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex column'
  }
})
export class GoogleMapsHome365Component implements OnInit, OnChanges {
  markerOptions = {draggable: false};
  markerPositions: MapsMarkers[] = [];
  @Input() circleCenter!: google.maps.LatLngLiteral;
  @Input() circleRadius!: number;
  display?: google.maps.LatLngLiteral;
  mapStart!: { lat: number, lng: number };
  zoom!: number;
  @Input() rawGeoArr?: MapsMarkers[] | null;
  @Output() clickedMarker!: EventEmitter<MapClick>;
  @Output() tileLoaded: EventEmitter<boolean>;
  @ViewChild(MapInfoWindow, {static: false}) infoWindow!: MapInfoWindow;
  protected map: any;
  @Input() withCircle = false;
  @Input() withMarks = true;

  constructor(private cd: ChangeDetectorRef) {
    this.clickedMarker = new EventEmitter<MapClick>();
    this.tileLoaded = new EventEmitter<boolean>();
  }

  ngOnInit() {
    if (this.rawGeoArr) {
      this.setMarkers(this.rawGeoArr);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.rawGeoArr) {
      this.setMarkers(this.rawGeoArr);
    }
  }

  markerClick(marker: MapsMarkers, event: google.maps.MapMouseEvent) {
    this.clickedMarker.emit({marker, event});
  }

  move(event: google.maps.MapMouseEvent) {
    this.display = event.latLng?.toJSON();
  }

  setMarkers(properties: MapsMarkers[]) {
    this.markerPositions = [];
    const bound = new google.maps.LatLngBounds();
    properties.forEach(property => {
      if (!('lng' in property)) {
        // @ts-ignore
        property.lng = property.lon;
      }
      this.markerPositions.push(property);
      bound.extend(new google.maps.LatLng(property.lat, property.lng));
    })
    this.mapStart = {
      lat: bound.getCenter().lat(),
      lng: bound.getCenter().lng()
    }
    if (this.rawGeoArr?.length === 1) {
      if (this.withCircle) {
        this.zoom = this.radiusToZoom(this.circleRadius / 1000);
      } else {
        this.zoom = 12;
      }
    } else {
      this.calcZoom(bound);
    }
    this.cd.detectChanges();
  }

  calcZoom(bound: any) {
    const distance_ne: number = this.getDistanceFromLatLonInKm(
      this.mapStart.lat,
      this.mapStart.lng,
      bound.getNorthEast().lat(),
      bound.getNorthEast().lng()
    );
    const distance_sw: number = this.getDistanceFromLatLonInKm(
      this.mapStart.lat,
      this.mapStart.lng,
      bound.getSouthWest().lat(),
      bound.getSouthWest().lng()
    );
    const distance = distance_ne > distance_sw ? distance_ne : distance_sw;
    this.zoom = this.radiusToZoom(distance);
  }

  getDistanceFromLatLonInKm(lat1: any, lon1: any, lat2: any, lon2: any) {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    // Distance in km
    return R * c;
  }

  deg2rad(deg: any) {
    return deg * (Math.PI / 180);
  }

  radiusToZoom(radius: number) {
    const _zoom: number = Math.round(14 - Math.log(radius) / Math.LN2);
    return this._isMobile() ? (_zoom === 0 ? 0 : _zoom - 1) : _zoom;
  }

  private _isMobile() {
    return window.innerWidth < 600;
  }

  onTileLoaded() {
    this.tileLoaded.emit(true);
    this.cd.detectChanges();
  }

}
